import { IoLogoJavascript, IoLogoReact } from "react-icons/io5";
import { SiAntdesign, SiCss3, SiExpress, SiFirebase, SiHtml5, SiMongodb, SiMysql, SiNextdotjs,SiNodedotjs,SiPostgresql,SiPrisma,SiRedux,SiTailwindcss,SiTypescript } from "react-icons/si";

import { IoCodeSlash } from "react-icons/io5";
export const skills = [
  { name: "JavaScript", logo: <IoLogoJavascript className="w-5 h-5 " /> },
  { name: "React JS", logo: <IoLogoReact className="w-5 h-5 " /> },
  { name: "Next JS", logo: <SiNextdotjs className="w-5 h-5 " /> },
  { name: "TypeScript", logo: <SiTypescript className="w-5 h-5 " /> },
  { name: "Redux", logo: <SiRedux className="w-5 h-5 " /> },
  { name: "Tailwind CSS", logo: <SiTailwindcss className="w-5 h-5 " /> },
  { name: "Ant Design", logo: <SiAntdesign className="w-5 h-5 " /> },
  { name: "Node JS", logo: <SiNodedotjs className="w-5 h-5 " /> },
  { name: "Express JS", logo: <SiExpress className="w-5 h-5 " /> },
  { name: "MongoDB", logo: <SiMongodb className="w-5 h-5 " /> },
  { name: "Mongoose", logo: <SiMongodb className="w-5 h-5 " /> }, // Assuming Mongoose is used alongside MongoDB
  { name: "Firebase", logo: <SiFirebase className="w-5 h-5 " /> },
  { name: "MySQL", logo: <SiMysql className="w-5 h-5 " /> },
  { name: "PostgreSQL", logo: <SiPostgresql className="w-5 h-5 " /> },
  { name: "Prisma", logo: <SiPrisma className="w-5 h-5 " /> },
  { name: "NextUI", logo: <IoCodeSlash className="w-5 h-5 " /> },
  { name: "HTML 5", logo: <SiHtml5 className="w-5 h-5 " /> },
  { name: "CSS 3", logo: <SiCss3 className="w-5 h-5 " /> },
];
